
import TreeView from '@mui/lab/TreeView';
import TreeItem,{treeItemClasses} from '@mui/lab/TreeItem';
import { AddBoxOutlined, IndeterminateCheckBoxOutlined as IndeterminateCheckBoxIcon} from '@mui/icons-material';

import { Box } from '@mui/system';
import { IconButton, Typography } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import useACL from 'helpers/Hooks/useACL';
type TreeNodeProps = { 
  node: any, 
  index: number,
  treeExpanded: string[], 
  generateDate: Date,
  handleClick: (e: React.MouseEvent, id: string, index: number, data: any) => void;
}

export const TreeNode = ({ node, treeExpanded, handleClick, index, generateDate }: TreeNodeProps) => {
  const { ACLGuard, Permission } = useACL();
  const acl = Permission.SalesCommission.CompanyCommissionTeamStructure;

  return (
  <TreeItem
    nodeId={String(node.id)}
    key={String(node.id)}
    icon={
      treeExpanded.includes(String(node.id)) ? (
        <IndeterminateCheckBoxIcon style={{ color: "#212121" }} />
      ) : (
        <AddBoxOutlined style={{ color: "#212121" }} />
      )
    }
    label={
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingTop: 1,
          paddingBottom: 1,
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <Typography className="text-xsTitle">
          {node.principal === "Internal" ? node.position.position : 'Property Agency'}
        </Typography>
        <ACLGuard acl={[acl.ADD_SUB, acl.UPDATE_SUB, acl.DELETE_SUB]}>
          <IconButton onClick={(e) => {
            e.stopPropagation()
            handleClick(
              e, 
              node.id, 
              index, 
              {...node, generateDate}
            )
          }} size="small">
            <MoreVert />
          </IconButton>
        </ACLGuard>
      </Box>
    }
  >
    {node.children?.length === 0 ? <Box/> : (
      node.children?.map((child: any, index: number) => (
        <TreeNode key={child.id} node={child} treeExpanded={treeExpanded} handleClick={handleClick} index={index} generateDate={generateDate}/>
      ))
    )}
  </TreeItem>
)};